export type ToastVariant = 'info' | 'success' | 'warning' | 'error';

export type ToastPayload = {
  message: string;
  variant?: ToastVariant;
  durationMs?: number;
  actionLabel?: string;
  onAction?: () => void;
};

export function showToast(payload: ToastPayload) {
  window.dispatchEvent(new CustomEvent<ToastPayload>('app:toast', { detail: payload }));
}
